<section class="c-section--static">
	<div class="c-section__header c-text--center">
		<div [class]="headerClass">
			<div class="o-container">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'SIFFI'">
						<a id="headerLogoSiffi" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup-success__header-logo c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'MINUDOC'">
						<a id="headerLogoMinudoc" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup-success__header-logo partner-signup-success__header-logo--minudoc c-header__logo c-logo c-logo--{{ logoSuffix }}"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'PREVISIT'">
						<a id="headerLogoPrevisit" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup-success__header-logo partner-signup-success__header-logo--previsit c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
					</div>
				</div>
			</div>

			<nav class="c-nav c-nav--tab-bar partner-signup-success__lang-nav">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<li class="c-nav__item" *ngIf="product === 'SIFFI'">
								<siffi-language-picker [currentLocale]="locale" (localeSelected)="setLocale($event)"></siffi-language-picker>
							</li>
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': langOpen }" *ngIf="product !== 'SIFFI'">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="toggleLangMenu()">
									<i class="c-flag c-flag--{{ getLocaleOption(locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ getLocaleOption(locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of locales; let $index = index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== locale" (click)="setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link">
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
		<main class="o-container c-container">
			<div class="o-grid o-grid--center-h">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@xl-and-up">
					<div class="c-content c-text--center">
						<div class="partner-signup-success__icon" aria-hidden="true">&#10003;</div>
						<p class="c-text c-text--s6 partner-signup-success__tag">{{ 'PartnerSignupSuccess.Tag' | translateUnauthenticated }}</p>
						<h1 class="c-text c-text--heading partner-signup-success__title">
							{{ 'PartnerSignupSuccess.Title' | translateUnauthenticated }}
							<span *ngIf="firstName">{{ firstName }}</span>
						</h1>
						<p class="c-text partner-signup-success__text">{{ 'PartnerSignupSuccess.Message' | translateUnauthenticated }}</p>
						<div class="c-form__group">
							<button type="button" class="c-button c-button--s1 c-form__center-button" (click)="navigateToRoot($event)">{{ 'PartnerSignupSuccess.Back_Home' | translateUnauthenticated }}</button>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</section>
